import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
export function UrgencyBanner() {
  return <section className="w-full py-4 md:py-6" style={{
    background: 'linear-gradient(135deg, #8B1A1A 0%, #B91C1C 40%, #92400E 100%)'
  }} data-id="element-199">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <p className="text-center font-black text-sm md:text-lg text-white tracking-wide mb-2 md:mb-3 flex items-center justify-center gap-2" data-id="element-201">
          🔥 PROMOCIÓN POR TIEMPO LIMITADO
        </p>

        <div className="flex items-center gap-3 mb-2" data-id="element-202">
          <div className="flex items-center gap-1.5 shrink-0" data-id="element-203">
            <AlertTriangleIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-300" data-id="element-204" />
            <span className="text-[11px] md:text-sm text-yellow-100 font-medium" data-id="element-205">
              Cupos disponibles agotándose
            </span>
          </div>
          <div className="flex-grow relative h-5 md:h-6 bg-black/30 rounded-full overflow-hidden" data-id="element-206">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '80%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="absolute inset-y-0 left-0 rounded-full" style={{
            background: 'linear-gradient(90deg, #F59E0B, #EF4444)'
          }} data-id="element-207" />
            <span className="absolute inset-0 flex items-center justify-end pr-2 text-[10px] md:text-xs font-bold text-white" data-id="element-208">
              80% tomados
            </span>
          </div>
        </div>

        <p className="text-center text-[11px] md:text-sm text-yellow-100/80" data-id="element-209">
          Últimos cupos a precio promocional — una vez agotados, vuelve al
          precio original.
        </p>
      </motion.div>
    </section>;
}